<script setup>
import { ref, computed } from 'vue';
import { useAdafStore } from '@organisms/ubiq-administration/store/adaf';
import { trans } from '../../_00_elements/translation';
import Button from '../../_01_atoms/components/Button.vue';

const adafStore = useAdafStore();
const dealPayment = adafStore.selectedDealPayment;
const { deal } = dealPayment;

const localAmount = ref(dealPayment.price);
const amountError = ref(null);

const emit = defineEmits([ 'close' ]);

const validateAmount = () => {
  if (localAmount.value === null || localAmount.value === undefined || localAmount.value < 0) {
    amountError.value = trans('gestion.adaf.slider.field.price.error_empty');
    return;
  }

  amountError.value = null;
};

const isValidateDisabled = computed(() => amountError.value);

const onValidate = async () => {
  validateAmount();

  if (isValidateDisabled.value) {
    return;
  }

  const isAmountEdited = await adafStore.editAmount(localAmount.value);

  if (isAmountEdited) {
    emit('close');
  }
};
</script>

<template>
  <div class="slider-adaf">
    <div class="slider-adaf__content">
      <div class="slider-adaf__summary">
        <div>
          <span class="slider-adaf__summary--title">
            {{ deal.buyer_orga_name }}
          </span>
          <span>{{ deal.buyer.full_name }}</span>
        </div>
        <div class="slider-adaf__summary--name">
          {{ adafStore.displaySpaceLabel(deal.first_office_offer.address) }}
          <br>{{ adafStore.displayOfficesLabel(deal.office_offers_collection) }}
        </div>
      </div>
      <div class="slider-adaf__form">
        <div>
          <label for="adaf-amount-price">{{ trans('gestion.adaf.slider.amount.field.price') }}</label>
          <div class="input-icon">
            <input
              id="adaf-amount-price"
              v-model="localAmount"
              :class="{ 'error': amountError }"
              type="number"
              min="0"
              @blur="validateAmount"
              @input="validateAmount"
            >
            <i>
              {{ trans('global.price_tax') }}&nbsp;{{ trans('global.currency_symbol') }}
            </i>
          </div>
          <span v-show="amountError" class="error-message">{{ amountError }}</span>
        </div>
      </div>
    </div>
    <div class="slider-adaf__footer">
      <div class="slider-adaf__footer-buttons">
        <Button variant="secondary" @click="emit('close')">
          {{ trans('gestion.adaf.slider.ctas.cancel') }}
        </Button>
        <Button
          variant="primary"
          :class="{ 'loading-btn': adafStore.ctaLoading }"
          :disabled="isValidateDisabled || adafStore.ctaLoading"
          @click="onValidate"
        >
          {{ trans('gestion.adaf.slider.ctas.create') }}
        </Button>
      </div>
    </div>
  </div>
</template>
